"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MultiSelectInput_1 = require("./MultiSelectInput");
exports.default = MultiSelectInput_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/MultiSelectInput/index.js
// module id = 1784
// module chunks = 8